import React from 'react';
import classNames from 'classnames';
import Image from 'next/image';

export interface GoogleNewsButtonProps {
  className?: string;
  urlKey?: string;
}

const image = '/next-assets/images/google-news.png';

const urls = {
  benzinga:
    'https://news.google.com/publications/CAAqJggKIiBDQklTRWdnTWFnNEtER0psYm5wcGJtZGhMbU52YlNnQVAB?hl=en-US&gl=US&ceid=US%3Aen',
  benzingaIndia: 'https://news.google.com/publications/CAAqBwgKMLf8ygsw55fiAw?hl=en-US&gl=US&ceid=US%3Aen',
};

export const GoogleNewsButton: React.FC<GoogleNewsButtonProps> = ({ className = '', urlKey = 'benzinga' }) => {
  return (
    <a
      aria-label="Read on Google News"
      className={classNames(
        'google-news-button flex h-10 max-h-10 min-h-10 w-[144px] items-center justify-center',
        className,
      )}
      href={urls[urlKey]}
      rel="noreferrer"
      target="_blank"
    >
      <Image alt="" className="rounded" height={40} priority src={image} width={144} />
    </a>
  );
};

export default GoogleNewsButton;
